// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-actualize[data-v-94464fc4]:deep(.v-btn__content span){margin-top:0}", ""]);
// Exports
module.exports = exports;
